import Vue from "vue";
import Router from "vue-router";
import HomeScreen from "./components/HomeScreen.vue";
import GameView from "./components/GameView.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    { path: "/", component: HomeScreen },
    { path: "/game/:mode", name: "game", component: GameView, props: true }
  ]
});
